export default __webpack_public_path__ + "static/media/nationwide.d47c041f.PNG";